import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=53f870be&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=53f870be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f870be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f870be')) {
      api.createRecord('53f870be', component.options)
    } else {
      api.reload('53f870be', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=53f870be&scoped=true&", function () {
      api.rerender('53f870be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aHCHLZ3chW1G/JS/comp/SearchFilterTokens.vue"
export default component.exports